module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"journeyProgress":"Du har fullført {percent}% av reisen","journeyCompleted":"Fullført","journey":"Reise","completeJourney":"Fullfør ferdigheten for å få livsnøkkel"},"en":{"journeyProgress":"{percent}% completed","journeyCompleted":"Completed","journey":"Journey","completeJourney":"Complete journey to get a life key"}}')
  delete Component.options._Ctor
}
